<template>
  <div>
    <van-nav-bar title="VIP任务" right-text="任务说明" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="task">
        <div class="daily-recode">
          <div class="task_box_title">每日任务</div>
          <ul>
            <li v-for="(item, i) in dailyTaskList" :key="i">
              <div style="
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 0.3rem;
                    background-color: #670000;
                  "></div>
              <div class="task_box_left" v-if="item.icon">
                <img v-lazy="item.icon" alt="" />
                <div class="task_title_des">
                  <div class="task_title">{{ item.mission_name }}</div>
                  <div class="task_des">{{ item.describe }}</div>
                </div>
              </div>
              <div class="task_box_left other" v-else>
                <div class="task_title other_title">
                  {{ item.mission_name }}
                </div>
                <div class="task_des other_desc">{{ item.describe }}</div>
              </div>
              <div class="task_box_right" v-if="percent(item.finishTimes, item.times) < 100">
                <div class="progress_text">
                  {{ item.finishTimes == null ? "0" : item.finishTimes }}/{{
                      item.times
                    }}
                </div>
                <div class="task_progress">
                  <div class="progress" :style="{
                        width: percent(item.finishTimes, item.times) + '%',
                      }"></div>
                </div>
              </div>
              <div class="task_box_right completed" v-else>已完成</div>
            </li>
          </ul>
        </div>
        <div class="daily-recode">
          <div class="task_box_title">更多任务</div>
          <ul>
            <li v-for="(item, i) in monthlyTaskList" :key="i">
              <div style="
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 0.3rem;
                    background-color: #670000;
                  "></div>
              <div class="task_box_left" v-if="item.icon">
                <img v-lazy="item.icon" alt="" />
                <div class="task_title_des">
                  <div class="task_title">{{ item.mission_name }}</div>
                  <div class="task_des">{{ item.describe }}</div>
                </div>
              </div>
              <div class="task_box_left other" v-else>
                <div class="task_title other_title">
                  {{ item.mission_name }}
                </div>
                <div class="task_des other_desc">{{ item.describe }}</div>
              </div>
              <div class="task_box_right" v-if="percent2(item.finishTimes, item.times) < 100">
                <div class="progress_text">
                  {{ item.finishTimes == null ? "0" : item.finishTimes }}/{{
                      num(item.times)
                    }}
                </div>
                <div class="task_progress">
                  <div class="progress" :style="{
                        width: percent2(item.finishTimes, item.times) + '%',
                      }"></div>
                </div>
              </div>
              <div class="task_box_right completed" v-else>已完成</div>
            </li>
          </ul>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
  import api from '../Api'
  export default {
    mixins: [api],
    data() {
      return {
        //每日任务列表
        dailyTaskList: [],
        //更多任务列表
        monthlyTaskList: [],
      };
    },
    created() {},
    mounted() {
      this.getDailyTaskList();
      this.getMonthlyTaskList();
    },
    methods: {
      onClickRight() {
        this.$router.push({
          name: "user.taskStatement"
        });
      },
      percent(num1, num2) {
        if (num1 == null) {
          num1 = 0;
        }
        return (Number(num1) / Number(num2)) * 100;
      },
      percent2(num1, num2) {
        if (num1 == null) {
          num1 = 0;
        }
        var arr = num2.split(",");
        num2 = arr[arr.length - 1];
        return (Number(num1) / Number(num2)) * 100;
      },
      num(str) {
        var arr = str.split(",");
        return arr[arr.length - 1];
      },

      // 获取每日任务列表
      getDailyTaskList() {
        this.$Ajax("/vip-task/exp-daily-list").then((rs) => {
          if (rs.code == 200) {
            this.dailyTaskList = rs.data;
          }
        });
      },

      // 获取更多任务列表
      getMonthlyTaskList() {
        this.$Ajax("/vip-task/exp-more-list").then((rs) => {
          if (rs.code == 200) {
            this.monthlyTaskList = rs.data;
          }
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  .daily-recode {
    margin: 0 0.75rem 0.6rem;
    background-color: #ffffff;
    border-radius: 0.7rem;
    padding: 0.6rem;

    ul {
      li {
        gap: 0.3rem;
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        .task_box_left {
          flex: 1;
        }
      }
    }
  }

  .task {
    margin-top: 2.5rem;
    padding: .6rem 0;
  }

  .task_box_title {
    color: #000000;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  .task_title {
    color: #000000;
    font-size: 0.6rem;
  }

  .task_des {
    color: #9e9e9e;
    font-size: 0.5rem;
  }

  .progress_text {
    font-size: 0.6rem;
    color: #9e9e9e;
    text-align: center;
  }

  .task_progress {
    width: 3.15rem;
    height: 0.25rem;
    background-color: #e4e4e4;
    border-radius: 10rem;
    overflow: hidden;

    .progress {
      height: 0.25rem;
      background-color: #670000;
    }
  }

  .completed {
    width: 3.15rem;
    height: 1.4rem;
    text-align: center;
    line-height: 1.4rem;
    background: #f3f2f2;
    border-radius: 1rem;
    color: #9e9e9e;
    font-size: 0.6rem;
  }
</style>